import { render } from "./UserPromotion.vue?vue&type=template&id=17c3c2b7&scoped=true"
import script from "./UserPromotion.vue?vue&type=script&lang=js"
export * from "./UserPromotion.vue?vue&type=script&lang=js"

import "./UserPromotion.vue?vue&type=style&index=0&id=17c3c2b7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17c3c2b7"]])

export default __exports__